import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/icon_shibiezimu.svg'


const _hoisted_1 = { class: "hisEditBox" }
const _hoisted_2 = { class: "hisEditTitle" }
const _hoisted_3 = { class: "hisEditList" }
const _hoisted_4 = { class: "hisEditOneTop" }
const _hoisted_5 = { class: "hisEditOneName" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "pointStyle" }
const _hoisted_9 = { class: "hisEditOneTime" }
const _hoisted_10 = { class: "hisEditOneMain" }
const _hoisted_11 = {
  key: 0,
  class: "subitem"
}
const _hoisted_12 = { class: "subitemRight" }
const _hoisted_13 = {
  key: 1,
  class: "subitem"
}
const _hoisted_14 = { class: "subitemImgBox" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "subitemLeft" }
const _hoisted_17 = {
  key: 2,
  class: "subitem"
}
const _hoisted_18 = { class: "subitemLeft" }
const _hoisted_19 = {
  key: 3,
  class: "subitem"
}
const _hoisted_20 = { class: "subitemLeft" }
const _hoisted_21 = {
  key: 4,
  class: "subitem"
}
const _hoisted_22 = {
  key: 5,
  class: "subitem"
}
const _hoisted_23 = {
  key: 6,
  class: "subitem"
}
const _hoisted_24 = {
  key: 7,
  class: "subitem"
}
const _hoisted_25 = {
  key: 8,
  class: "subitem"
}
const _hoisted_26 = { class: "hisEditOneTop" }
const _hoisted_27 = { class: "hisEditOneTopTitle" }
const _hoisted_28 = { class: "topTitleLeft" }
const _hoisted_29 = { class: "hisEditOneName" }
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { class: "hisEditOneTime" }
const _hoisted_34 = { class: "textStyle" }
const _hoisted_35 = { class: "textStyleRight" }
const _hoisted_36 = { class: "textStyle" }
const _hoisted_37 = { class: "textStyleRight" }
const _hoisted_38 = {
  key: 0,
  class: "textStyle"
}
const _hoisted_39 = { class: "textStyleRight" }

import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted,getCurrentInstance} from 'vue'
// 时间处理方法
import { timeInfo, timeInfominute, timedata } from '@/components/public-method/time-method';
import {controlType } from "./icon.ts"

export default /*@__PURE__*/_defineComponent({
  __name: 'historyEdit',
  props: {
    logs:Array,
    initdata:Array,
    imgs:Array,
    roles:Array,

},
  emits: ['closeThis',''],
  setup(__props, { emit: __emit }) {

const props = __props
// 引入页面图标
let { proxy } = getCurrentInstance()
const emit = __emit
// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}
const showData=ref([])
onMounted(()=>{
    console.log('历史记录')
    console.log(props)
    showData.value=props.logs|| []
   
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "历史编辑记录", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: closeBox
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (showData.value.length>0)
        ? (_openBlock(), _createBlock(_component_el_scrollbar, {
            key: 0,
            height: "100%"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showData.value.sort((a, b) => b.createTime - a.createTime), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "hisEditOne",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (props.imgs.filter(it=>it.userId==item.userId)[0].avatar != '')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(proxy).getimgUrl+  props.imgs.filter(it=>it.userId==item.userId)[0].avatar,
                            alt: ""
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      (props.imgs.filter(it=>it.userId==item.userId)[0].avatar == '')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(headPic),
                            alt: ""
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(props.imgs.filter(it=>it.userId==item.userId)[0].nickname), 1),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(controlType).filter(it=>it.value==item.type)[0].text), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(_unref(timedata)(item.createTime*1)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (item.type=='modifyTime')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "subitemLeft" }, "时间码", -1)),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(timeInfo)(item.data.beginTime)) + " - " + _toDisplayString(_unref(timeInfo)(item.data.endTime)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.type=='modifyRole')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              src: _unref(proxy).getimgUrl+props.roles.filter(it=>it.id==item.data.role)[0].avatar,
                              alt: ""
                            }, null, 8, _hoisted_15),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(props.roles.filter(it=>it.id==item.data.role)[0].name), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (item.type=='modifyOriginalText')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(item.data.text), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.type=='modifyTranslationText')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(item.data.text), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (item.type=='modifyOriginalColor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", {
                            style: _normalizeStyle({background:item.data.textColor}),
                            class: "subitemColor"
                          }, null, 4)
                        ]))
                      : _createCommentVNode("", true),
                    (item.type=='modifyTranslationColor')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("span", {
                            style: _normalizeStyle({background:item.data.textColor}),
                            class: "subitemColor"
                          }, null, 4)
                        ]))
                      : _createCommentVNode("", true),
                    (item.type=='add')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[2] || (_cache[2] = [
                          _createElementVNode("span", { class: "subitemLeft" }, "添加字幕", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (item.type=='delete')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[3] || (_cache[3] = [
                          _createElementVNode("span", { class: "subitemLeft" }, "删除", -1)
                        ])))
                      : _createCommentVNode("", true),
                    (item.type=='restore')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[4] || (_cache[4] = [
                          _createElementVNode("span", { class: "subitemLeft" }, "撤销删除", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.initdata, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "hisEditOneinit",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[5] || (_cache[5] = _createElementVNode("img", {
                          src: _imports_0,
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(item.subtitleType =='1' ? 'AI字幕' : 'srt字幕'), 1)
                      ]),
                      _createElementVNode("div", null, _toDisplayString(_unref(timedata)(item.createTime*1)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (props.imgs.length>0&&props.imgs.filter(it=>it.userId==item.userId)[0].avatar != undefined)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(proxy).getimgUrl+props.imgs.filter(it=>it.userId==item.userId)[0].avatar,
                            alt: ""
                          }, null, 8, _hoisted_30))
                        : _createCommentVNode("", true),
                      (props.imgs.length==0||props.imgs.filter(it=>it.userId==item.userId)[0].avatar == undefined)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(headPic),
                            alt: ""
                          }, null, 8, _hoisted_31))
                        : _createCommentVNode("", true),
                      (props.imgs.length>0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(props.imgs.filter(it=>it.userId==item.userId)[0].nickname), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "textStyleLeft" }, "时间码", -1)),
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(timeInfo)(item.beginTime)) + " -- " + _toDisplayString(_unref(timeInfo)(item.endTime)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "textStyleLeft" }, "原文", -1)),
                        _createElementVNode("div", _hoisted_37, _toDisplayString(item.original.text), 1)
                      ]),
                      ( item.translation!=undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "textStyleLeft" }, "译文", -1)),
                            _createElementVNode("div", _hoisted_39, _toDisplayString(item.translation.text), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})